<template>
  <a-layout class="change-password">
    <div class="content-base container">
      <a-button type="default" class="go-back" @click="goBack">
        <a-icon type="left" />
        Regresar
      </a-button>
      <a-row type="flex" justify="center">
        <a-col>
          <ChangePasswordForm />
        </a-col>
      </a-row>
    </div>
  </a-layout>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import ChangePasswordForm from "@/components/ChangePasswordForm.vue";
import { pageTitle } from "@/utils/utils";
import labels from "@/utils/labels";
export default {
  components: { ChangePasswordForm },
  name: "ChangePassword",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.changePasswordForm.title),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.changePasswordForm.title,
      },
    ],
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.change-password {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .content-base {
    padding: 10px;

    max-width: 100% !important;

    .go-back {
      background: transparent !important;
      color: var(--btn-bg-primary);
      border-color: var(--btn-bg-primary);
      margin-bottom: 10px;
    }
  }
}
</style>
